import { html } from "lit";
var icon_alert_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M13.672 4.65c1.185-2.14 3.471-2.14 4.655 0l11.167 20.19c1.17 2.12.005 4.115-2.411 4.115H4.918c-2.418 0-3.583-1.996-2.411-4.115zm2.985.925c-.458-.827-.857-.827-1.314 0L4.177 25.764c-.47.85-.218 1.281.74 1.281h22.166c.958 0 1.21-.431.74-1.281zM16 23a1 1 0 110 2 1 1 0 010-2zm0-14a1 1 0 011 1v9a1 1 0 01-2 0v-9a1 1 0 011-1z" />
  </svg>
`;
export {
  icon_alert_default as default
};
//# sourceMappingURL=icon-alert.js.map
